import { Box, ContentBlock, Stack } from 'braid-design-system';

import { Nav } from 'src/components/Nav/Nav';
import { PageWrapper } from 'src/components/PageWrapper/PageWrapper';
import type { PageProps } from 'src/types';
import { slugify } from 'src/utils/slugify';

import { ContentState } from './components/ContentState';

export const LinkYourSoftware = ({ slug }: PageProps) => {
  const pageTrackingProps = {
    page: `${slugify({ str: slug })}`,
    eventName: `${slugify({ str: slug })}-viewed`,
    siteSection: 'partners',
  };

  return (
    <PageWrapper pageTrackingProps={pageTrackingProps} title={slug}>
      <Nav activeTab="link-your-software" />
      <Box
        paddingX={['gutter', 'gutter', 'none']}
        paddingY={['xlarge', 'xlarge', 'xxlarge']}
      >
        <Stack space="xlarge">
          <ContentBlock>
            <ContentState />
          </ContentBlock>
        </Stack>
      </Box>
    </PageWrapper>
  );
};
